import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { Picking } from "interfaces/picking";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_PICKINGS_" }
);

export interface PaginatePickingsState extends IState {
  data: Picking[];
}

const INITIAL_STATE: PaginatePickingsState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginatePickingsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginatePickingsState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data as Picking[] },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginatePickingsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginatePickings = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginatePickingsTypes = Types;
export const PaginatePickingsActions = Creators;
